export default function ComparisonSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-600 mb-3 block">
            Feature Comparison
          </span>
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            <strong>ACbuyspreadsheet</strong> vs Traditional Buying
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            See how the <strong>acbuyspreadsheet</strong> system outperforms conventional shopping methods
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200/70">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-primary-600 text-background-50">
                <th className="px-5 py-4 text-sm font-semibold">Feature</th>
                <th className="px-5 py-4 text-sm font-semibold">
                  <strong>ACbuyspreadsheet</strong>
                </th>
                <th className="px-5 py-4 text-sm font-semibold">Traditional Buying</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200/70">
              <tr className="bg-background-50">
                <td className="px-5 py-4 text-sm font-medium text-foreground-800">Speed</td>
                <td className="px-5 py-4 text-sm text-primary-700 font-semibold">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-check-line text-primary-500"></i>
                    Very Fast
                  </span>
                </td>
                <td className="px-5 py-4 text-sm text-foreground-600">Slow & Manual</td>
              </tr>
              <tr className="bg-background-50/50">
                <td className="px-5 py-4 text-sm font-medium text-foreground-800">Organization</td>
                <td className="px-5 py-4 text-sm text-primary-700 font-semibold">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-check-line text-primary-500"></i>
                    Fully Structured
                  </span>
                </td>
                <td className="px-5 py-4 text-sm text-foreground-600">Unstructured & Chaotic</td>
              </tr>
              <tr className="bg-background-50">
                <td className="px-5 py-4 text-sm font-medium text-foreground-800">Tracking</td>
                <td className="px-5 py-4 text-sm text-primary-700 font-semibold">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-check-line text-primary-500"></i>
                    Real-time Tracking
                  </span>
                </td>
                <td className="px-5 py-4 text-sm text-foreground-600">None or Manual</td>
              </tr>
              <tr className="bg-background-50/50">
                <td className="px-5 py-4 text-sm font-medium text-foreground-800">Category Navigation</td>
                <td className="px-5 py-4 text-sm text-primary-700 font-semibold">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-check-line text-primary-500"></i>
                    Pre-organized Categories
                  </span>
                </td>
                <td className="px-5 py-4 text-sm text-foreground-600">Scattered Across Sites</td>
              </tr>
              <tr className="bg-background-50">
                <td className="px-5 py-4 text-sm font-medium text-foreground-800">Price Comparison</td>
                <td className="px-5 py-4 text-sm text-primary-700 font-semibold">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-check-line text-primary-500"></i>
                    Built-in Structure
                  </span>
                </td>
                <td className="px-5 py-4 text-sm text-foreground-600">Requires Manual Work</td>
              </tr>
              <tr className="bg-background-50/50">
                <td className="px-5 py-4 text-sm font-medium text-foreground-800">Learning Curve</td>
                <td className="px-5 py-4 text-sm text-primary-700 font-semibold">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-check-line text-primary-500"></i>
                    Minutes to Master
                  </span>
                </td>
                <td className="px-5 py-4 text-sm text-foreground-600">Hours of Setup</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Try ACbuyspreadsheet Now
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}